import React from 'react';
import Chart from 'react-apexcharts';
import { formatarNumero } from './UsinaResumoCards';

const MESES_CURTOS = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

const COR_BARRA = '#4c9f70';
const COR_SELECIONADA = '#1b6b46';

export default function UsinaGraficoMensal({ serie, ano, anos, mesSelecionado, onSelecionarMes, onTrocarAno, loading }: any) {
    const dados = serie || [];
    const estimadoMensal = dados.length > 0 ? dados[0].estimado : 0;
    const totalAno = dados.reduce((soma: number, item: any) => soma + (item.geracao || 0), 0);

    const series: any[] = [
        {
            name: 'Geração (kWh)',
            type: 'column',
            data: dados.map((item: any) => ({ x: MESES_CURTOS[item.mes - 1], y: item.geracao })),
        },
    ];

    if (estimadoMensal > 0) {
        series.push({
            name: 'Estimado (kWh)',
            type: 'line',
            data: dados.map((item: any) => ({ x: MESES_CURTOS[item.mes - 1], y: estimadoMensal })),
        });
    }

    const options: any = {
        chart: {
            type: 'line',
            stacked: false,
            toolbar: { show: false },
            zoom: { enabled: false, allowMouseWheelZoom: false },
            animations: { enabled: false },
            events: {
                dataPointSelection: (evento: any, contexto: any, config: any) => {
                    const item = dados[config.dataPointIndex];
                    if (item && onSelecionarMes) onSelecionarMes(item.mes);
                },
            },
        },
        plotOptions: { bar: { columnWidth: '60%' } },
        stroke: { width: estimadoMensal > 0 ? [0, 2] : [0], dashArray: estimadoMensal > 0 ? [0, 4] : [0] },
        colors: [
            ({ dataPointIndex }: any) => (dados[dataPointIndex]?.mes === mesSelecionado ? COR_SELECIONADA : COR_BARRA),
            '#2f80ed',
        ],
        states: {
            hover: { filter: { type: 'darken', value: 0.88 } },
            active: { filter: { type: 'none' } },
        },
        dataLabels: { enabled: false },
        xaxis: { tickAmount: 12, tickPlacement: 'on', labels: { rotate: 0 } },
        yaxis: { min: 0, forceNiceScale: true, labels: { formatter: (valor: number) => `${Number(valor).toFixed(0)}` } },
        markers: { size: 0 },
        legend: { show: false },
        tooltip: { shared: true, y: { formatter: (valor: number) => `${Number(valor).toFixed(2)} kWh` } },
    };

    const listaAnos = anos && anos.length > 0 ? anos : [ano];

    return (
        <div className="usina-bloco is-clicavel">
            <div className="usina-bloco-header">
                <div className="usina-bloco-titulo">
                    Ano
                    <span className="usina-bloco-hint">clique num mês para abrir os dias</span>
                </div>
                <div className="usina-bloco-controles">
                    <span className="usina-bloco-total">{formatarNumero(totalAno)} kWh no ano</span>
                    <select
                        className="form-control form-control-sm"
                        style={{ width: 100 }}
                        value={ano}
                        onChange={(evento) => onTrocarAno(Number(evento.target.value))}
                    >
                        {listaAnos.map((item: number) => <option key={item} value={item}>{item}</option>)}
                    </select>
                </div>
            </div>

            <div className="usina-chart-box is-mensal">
                {loading
                    ? <div className="usina-vazio">Carregando...</div>
                    : <Chart options={options} series={series} type="line" width="100%" height="100%" />}
            </div>
        </div>
    );
}
